var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#4C9F38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09998 11.0576H6.02362L7.4022 8.0349L8.09149 12.6485L9.73518 9.69652L10.7249 15.3L13.9063 4.80005L15.3732 7.82278",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8754 12.7704C15.8754 12.7704 16.9554 11.6715 17.5001 11.1267C17.6675 10.9592 17.8 10.7026 17.8 10.3955C17.8 9.85367 17.5664 9.13306 16.7627 9.13306C16.3052 9.13306 15.9232 9.57385 15.8817 9.62054C15.8191 9.69072 15.7467 9.68727 15.6941 9.62054C15.6554 9.57142 15.2705 9.13306 14.813 9.13306C14.0094 9.13306 13.7758 9.85367 13.7758 10.3955C13.7758 10.7026 13.9083 10.9592 14.0757 11.1267C14.6204 11.6715 15.7004 12.7704 15.7004 12.7704C15.7598 12.8335 15.8066 12.8346 15.8754 12.7704Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.fd3dfb34ad0d32b0953d638e467d0459.svg";
export { ForwardRef as ReactComponent };